export default "__VITE_ASSET__DiNeUpnu__"